import React from 'react';
import { Search, X } from 'lucide-react';
import { FUNDING_CLIENT_STATUSES } from '../../utils/funding/constants';
import { getPlatformAgencyId, getPlatformAgencyLabel } from '../../services/platform/platformAgenciesService';

const FundingClientFilters = ({
  search,
  status,
  onSearchChange,
  onStatusChange,
  showAgencyFilter = false,
  agencies = [],
  agencyId = '',
  onAgencyChange,
  agenciesLoading = false,
  agenciesError = null,
}) => (
  <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-3">
    <div className="relative min-w-[220px] flex-1">
      <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-[var(--fg-muted)]" />
      <input
        type="search"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search clients, business, email..."
        className="w-full rounded-xl border border-[var(--fg-line)] bg-white py-2.5 pl-10 pr-9 text-sm outline-none ring-[var(--fg-accent)] focus:ring-2 dark:bg-[rgba(11,31,24,0.65)]"
        data-testid="funding-clients-search"
      />
      {search ? (
        <button
          type="button"
          onClick={() => onSearchChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--fg-muted)] hover:text-[var(--fg-text)]"
          aria-label="Clear search"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>

    <select
      value={status}
      onChange={(event) => onStatusChange(event.target.value)}
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2.5 text-sm text-[var(--fg-text)] outline-none ring-[var(--fg-accent)] focus:ring-2 dark:bg-[rgba(11,31,24,0.65)]"
      data-testid="funding-clients-status-filter"
    >
      <option value="">All statuses</option>
      {FUNDING_CLIENT_STATUSES.map((item) => (
        <option key={item} value={item}>{item}</option>
      ))}
    </select>

    {showAgencyFilter ? (
      <select
        value={agencyId}
        onChange={(event) => onAgencyChange(event.target.value)}
        className="min-w-[180px] rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2.5 text-sm text-[var(--fg-text)] outline-none ring-[var(--fg-accent)] focus:ring-2 dark:bg-[rgba(11,31,24,0.65)]"
        data-testid="funding-clients-agency-filter"
        disabled={agenciesLoading}
        aria-label="Filter by agency"
      >
        <option value="">{agenciesLoading ? 'Loading agencies…' : 'All agencies'}</option>
        {agencies.map((agency) => {
          const id = getPlatformAgencyId(agency);
          return (
            <option key={id} value={id}>
              {getPlatformAgencyLabel(agency)}
            </option>
          );
        })}
      </select>
    ) : null}
    </div>

    {showAgencyFilter && agenciesError ? (
      <div
        className="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-200"
        data-testid="funding-clients-agency-error"
        role="alert"
      >
        {agenciesError}
      </div>
    ) : null}
  </div>
);

export default FundingClientFilters;
